module.exports = __webpack_public_path__ + "static/media/faq.16544985.svg";